import type {
  APILibraryTemplateMetadataRequestType,
  APILibraryTemplateRequestType,
  APILibraryTemplateResponseType,
} from "@/core/data_sources/models/APILibraryTemplate";
import type { BasicQuery } from "@/core/data_sources/services";
import { get, patch, post, put } from "@/core/utils/request";

export function getTemplates<Q extends BasicQuery>(query: Q) {
  return get<APILibraryTemplateResponseType[]>("/library/templates/", {
    params: query,
  });
}
export function getTemplateById(id: number) {
  return get<APILibraryTemplateResponseType>(`/library/templates/${id}/`);
}
export function patchTemplate(
  id: number,
  data: APILibraryTemplateMetadataRequestType,
) {
  return patch<
    APILibraryTemplateMetadataRequestType,
    APILibraryTemplateResponseType
  >(`/library/templates/${id}/`, data);
}
export function putTemplate(
  id: number,
  data: APILibraryTemplateMetadataRequestType,
) {
  return put<
    APILibraryTemplateMetadataRequestType,
    APILibraryTemplateResponseType
  >(`/library/templates/${id}/`, data);
}
export function publishTemplate(id: number) {
  return post<undefined, APILibraryTemplateResponseType>(
    `/library/templates/${id}/publish/`,
  );
}
export function archiveTemplate(id: number) {
  return post<undefined, APILibraryTemplateResponseType>(
    `/library/templates/${id}/archive/`,
  );
}
export function importTemplate(data: APILibraryTemplateRequestType) {
  return post<APILibraryTemplateRequestType, APILibraryTemplateResponseType>(
    "/library/templates/import/",
    data,
  );
}
